/**
 * Welcome suggestion chips for Help (/راهنما) mode.
 * Later these can be loaded from FAQ tags / popular questions.
 */

export type McpHelpSuggestion = {
  id: string;
  label: string;
  /** Question text sent when the chip is clicked. */
  question: string;
};

export const MCP_HELP_SUGGESTIONS: McpHelpSuggestion[] = [
  {
    id: 'crawl-limits',
    label: 'محدودیت ابزار خزش',
    question: 'آیا در ابزار خزش محدودیت تعداد URL وجود دارد؟'
  },
  {
    id: 'keyword-rank',
    label: 'رتبه‌بندی کلمات کلیدی',
    question: 'چطور رتبه کلمات کلیدی سایت را بررسی کنم؟'
  },
  {
    id: 'site-audit',
    label: 'آنالیز فنی سایت',
    question: 'ابزار آنالیز فنی سایت چه مواردی را بررسی می‌کند؟'
  },
  {
    id: 'billing',
    label: 'اشتراک و محدودیت‌ها',
    question: 'محدودیت‌های پلن من چیست و چطور ارتقا دهم؟'
  }
];
